module.exports = __webpack_public_path__ + "img/logo-white.34058c15.png";